import axios from 'axios';

const getCadastrosAdicionais = params => axios.get('/cadastros-adicionais', { params });

export default {
  getCadastrosAdicionais,
};
